import { getDefaultStore } from 'jotai'
import { DEFAULT_LOCALE, type SupportedLocaleCodes } from 'src/i18n/constants'
import i18n from 'src/i18n/i18next'
import { executeSetPreferences } from 'src/services/apollo/preference'
import { getLocale, localeAtom, setLocaleToUrl } from 'src/stores/locale'
import { getMayTokenBeValid } from 'src/utils/token'
export { DEFAULT_LOCALE, type SupportedLocaleCodes, getLocale, localeAtom }

const store = getDefaultStore()

store.sub(localeAtom, () => {
  const locale = store.get(localeAtom)
  i18n.changeLanguage(locale)
  setLocaleToUrl(locale)
})

export async function updateLangPreference(lang: SupportedLocaleCodes) {
  const mayTokenBeValid = getMayTokenBeValid()
  if (mayTokenBeValid) await executeSetPreferences({ value: { lang } })
}
